export default "__VITE_ASSET__Bmxct434__"